/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Tool_Saved_PreferenceInputs */



/**
* | output |
* | --- |
* | "Saved as a preference" |
*
* @param {Memory_Tool_Saved_PreferenceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_tool_saved_preference = /** @type {((inputs?: Memory_Tool_Saved_PreferenceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Tool_Saved_PreferenceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Als Präferenz gespeichert")
	return /** @type {LocalizedString} */ ("Saved as a preference")
});